import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-accounting',
  templateUrl: './select-accounting.component.html',
  styleUrls: ['./select-accounting.component.css']
})
export class SelectAccountingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
